import { render } from "./WePass.vue?vue&type=template&id=1cf0d918"
import script from "./WePass.vue?vue&type=script&lang=js"
export * from "./WePass.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__